import { useSidebarSummaryContext } from '../../../../SidebarSummary.context';
import {
  StarFieldChild,
  StarFieldWrapper,
  StyledBasicTitle,
  StyledBiggerSubtitle,
  StyledImage,
  Wrapper,
} from './OpenAnswerAnimation.styled';

interface OpenAnswerAnimationProps {
  hideAnimation: boolean;
  onAnimationEnd?: () => void;
}

export const OpenAnswerAnimation = ({
  hideAnimation,
  onAnimationEnd,
}: OpenAnswerAnimationProps) => {
  const {
    state: { isOpen },
    config: { getTranslation },
  } = useSidebarSummaryContext();

  const items = Array(8).fill(0);

  const handleAnimationEnd = () => {
    if (onAnimationEnd && hideAnimation) {
      onAnimationEnd();
    }
  };

  return (
    <Wrapper $activeHideAnimation={hideAnimation} onAnimationEnd={handleAnimationEnd}>
      <StarFieldWrapper $activeAnimation={isOpen}>
        {items.map((_, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <StarFieldChild key={index} $activeAnimation={isOpen} />
        ))}
      </StarFieldWrapper>
      <StyledImage
        src="https://static.genially.com/genially/activities/openAnswerAggregated"
        alt="Open Answer Aggregated Image"
        $activeAnimation={isOpen}
      />
      <StyledBasicTitle $activeAnimation={isOpen}>
        {getTranslation('__new.content.interactiveQuestion.sidebar.openAnswer.title')}
      </StyledBasicTitle>
      <StyledBiggerSubtitle $activeAnimation={isOpen}>
        {getTranslation('__new.content.interactiveQuestion.sidebar.openAnswer.subtitle')}
      </StyledBiggerSubtitle>
    </Wrapper>
  );
};
